var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5913_609)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1346 0H2.68301C1.70332 0 0.911133 0.773438 0.911133 1.72969V22.2656C0.911133 23.2219 1.70332 24 2.68301 24H23.1346C24.1143 24 24.9111 23.2219 24.9111 22.2703V1.72969C24.9111 0.773438 24.1143 0 23.1346 0ZM8.03145 20.4516H4.46895V8.99531H8.03145V20.4516ZM6.2502 7.43438C5.10645 7.43438 4.18301 6.51094 4.18301 5.37187C4.18301 4.23281 5.10645 3.30937 6.2502 3.30937C7.38926 3.30937 8.3127 4.23281 8.3127 5.37187C8.3127 6.50625 7.38926 7.43438 6.2502 7.43438ZM21.3627 20.4516H17.8049V14.8828C17.8049 13.5562 17.7814 11.8453 15.9533 11.8453C14.1018 11.8453 13.8205 13.2937 13.8205 14.7891V20.4516H10.2674V8.99531H13.6799V10.5609H13.7268C14.2002 9.66094 15.3627 8.70938 17.0924 8.70938C20.6971 8.70938 21.3627 11.0813 21.3627 14.1656V20.4516Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5913_609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.911133)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5ae105d4057df3148ec4c730696bd2e7.svg";
export { ForwardRef as ReactComponent };